// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productCarouselProductStyles } from "@ces/Overrides/Components/ProductCarouselProduct";
import { xScreen } from "@ces/XDL/Utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { css } from "styled-components";

productCarouselProductStyles.productImageStyles = {};
productCarouselProductStyles.productGridContainerStyles = {
    container: {
        css: css`
            max-width: 317px;
            border: 0;
            padding: 0;

            ${xScreen("lte", "md")} {
                max-width: 358px;
            }
            ${xScreen("lte", 767)} {
                max-width: 328px;
            }
            & > .top-section {
                display: flex;
                flex-direction: row;
                column-gap: 12px;
                & > .image-section {
                    margin-bottom: 0;
                }
            }
        `,
    },
    qtyInfo: {
        css: css`
            ${xScreen("lte", "sm")} {
                margin-bottom: 8px;
            }
        `,
    },
    image: {
        css: css`
            position: relative;
            width: 91px;
            height: 91px;
            margin: 0 auto;
        `,
    },
    priceAndActions: {
        css: css`
            display: flex;
            flex-direction: column;
            gap: 8px;
            margin-bottom: 8px;
        `,
    },
};

productCarouselProductStyles.badges = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        margin-top: 25px;
        & > div:empty {
            display: none;
        }
    `,
};

productCarouselProductStyles.productAddToListLinkStyles = {
    link: {
        css: css`
            margin-left: auto;
        `,
    },
};
productCarouselProductStyles.productPriceWrapper = {
    css: css``,
};

productCarouselProductStyles.productPartNumbersStyles = {};

const tooltipWrapperCss: InjectableCss = {
    css: css`
        min-height: 16px;

        ${xScreen("lte", "md")} {
            && div[data-tippy-root] {
                top: -15px !important;
            }
        }
    `,
};

productCarouselProductStyles.productQtyInfo = {
    wrapper: {
        css: css`
            width: 100%;
            flex-direction: column;
        `,
    },
    minOrderedQtyWrapper: tooltipWrapperCss,
    multipleSaleQtyWrapper: tooltipWrapperCss,
};
